import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {VariableNode} from "#template/nodes/variable/variable-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

export type R1VariableParameters = {
    range: [number, number]
    default: number
}

const r1VariableDefinition: TemplateNodeDefinition<R1VariableParameters> = {
    nodeClass: "R1Variable",
    validation: {
        parameters: z.object({
            range: z.tuple([z.number(), z.number()]),
            default: z.number(),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class R1Variable extends VariableNode<R1VariableParameters> {
    public override get definition() {
        return r1VariableDefinition
    }
}
